"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault")["default"];
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.DuplicateItem3D = exports.DuplicateItem2D = exports.DuplicateItem = void 0;
var _promise = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/promise"));
var _indexOf = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/index-of"));
var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));
var _splice = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/splice"));
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));
var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));
var _createSuper2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createSuper"));
var _InsertItem2 = require("./InsertItem");
var _ICad = require("./ICad");
var DuplicateItem = /*#__PURE__*/function (_InsertItem) {
  (0, _inherits2["default"])(DuplicateItem, _InsertItem);
  var _super = (0, _createSuper2["default"])(DuplicateItem);
  function DuplicateItem() {
    (0, _classCallCheck2["default"])(this, DuplicateItem);
    return _super.apply(this, arguments);
  }
  (0, _createClass2["default"])(DuplicateItem, [{
    key: "duplicate",
    value: function duplicate(rule, project, iCad, forcedVariants, centerZoomAfterInsert) {
      var _this = this;
      this.hasToCenterZoom = centerZoomAfterInsert;
      return new _promise["default"](function (resolve, reject) {
        var res = {
          rule: rule,
          skipBasket: false
        };
        _this.iCad = iCad;
        _this.forcedResolver = forcedVariants;
        try {
          project.setEnvWall(iCad.getEnvWallJson());
        } catch (err) {
          reject(err);
        }
        _this.insertItemPrjFromRule(res, project).then(resolve)["catch"](reject);
      });
    }
  }, {
    key: "duplicateMulti",
    value: function duplicateMulti(rules, clonedId, project, iCad, forcedVariants, centerZoomAfterInsert) {
      var _this2 = this;
      this.hasToCenterZoom = centerZoomAfterInsert;
      return new _promise["default"](function (resolve, reject) {
        _this2.iCad = iCad;
        _this2.forcedResolver = forcedVariants;
        try {
          project.setEnvWall(iCad.getEnvWallJson());
        } catch (err) {
          reject(err);
        }
        var isSinglePlacer = false;
        if (rules.length == 1) {
          var rowToCopy = project.getRowByUid(clonedId[0]);
          isSinglePlacer = rowToCopy.father != null;
        }
        if (isSinglePlacer) {
          var res = {
            rule: rules[0],
            skipBasket: false
          };
          _this2.insertItemPrjFromRule(res, project).then(resolve)["catch"](reject);
        } else {
          _this2.insertItemsPrjFromRules(rules, project, clonedId).then(resolve)["catch"](reject);
        }
      });
    }
  }, {
    key: "hasNoFatherInList",
    value: function hasNoFatherInList(project, clonedId, id) {
      if ((0, _indexOf["default"])(clonedId).call(clonedId, id) > -1) {
        var prjRow = project.getRowByUid(id);
        if (prjRow.father === null) {
          return false;
        } else {
          return this.hasNoFatherInList(project, clonedId, prjRow.father.idRow);
        }
      } else {
        return true;
      }
    }
  }, {
    key: "insertItemsPrjFromRules",
    value: function insertItemsPrjFromRules(rules, project, clonedId) {
      var _this3 = this;
      return new _promise["default"](function (resolve, reject) {
        var historyRow = project.getLastHistoryEntry();
        var indexToRemove = [];
        (0, _forEach["default"])(clonedId).call(clonedId, function (rowId, i, src) {
          if (_this3.hasNoFatherInList(project, clonedId, rowId)) {
            indexToRemove.push({
              id: rowId,
              index: i
            });
          }
        });
        while (indexToRemove.length) {
          var item = indexToRemove.pop();
          var index = item.index;
          (0, _splice["default"])(clonedId).call(clonedId, index, 1);
          (0, _splice["default"])(rules).call(rules, index, 1);
        }
        if (rules.length) {
          var rowsRules = [];
          (0, _map["default"])(rules).call(rules, function (rule, index) {
            rowsRules.push({
              rule: rule,
              row: project.getRowByUid(clonedId[index])
            });
          });
          _this3.addItemsPrj(rowsRules, historyRow.catalog, historyRow.currentModel.header, project).then(function (res) {
            var newRows = res.rows;
            var mapIds = {};
            if (clonedId.length > 0) {
              for (var i = 0; i < newRows.length; i++) {
                if (newRows[i] !== null) mapIds[clonedId[i]] = newRows[i].uniqueid;
              }
            }
            _this3.afterInsertDuplicatedItemsPrj((0, _filter["default"])(newRows).call(newRows, function (r) {
              return !!r;
            }), project, mapIds).then(resolve)["catch"](reject);
          })["catch"](reject);
        } else {
          resolve(null);
        }
      });
    }
  }, {
    key: "resolveInsertItemsCad",
    value: function resolveInsertItemsCad(rows, prj) {
      var _this4 = this;
      var rowIds = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      return new _promise["default"](function (resolve, reject) {
        _this4.iCad.lockCallbacks(true);
        _this4.iCad.insertItemDuplicate(prj, rows, rowIds);
        _this4.iCad.lockCallbacks(false);
        resolve(null);
      });
    }
  }]);
  return DuplicateItem;
}(_InsertItem2.InsertItem);
exports.DuplicateItem = DuplicateItem;
var DuplicateItem3D = /*#__PURE__*/function (_DuplicateItem) {
  (0, _inherits2["default"])(DuplicateItem3D, _DuplicateItem);
  var _super2 = (0, _createSuper2["default"])(DuplicateItem3D);
  function DuplicateItem3D(loader) {
    (0, _classCallCheck2["default"])(this, DuplicateItem3D);
    return _super2.call(this, loader);
  }
  (0, _createClass2["default"])(DuplicateItem3D, [{
    key: "afterSelectedPlacer",
    value: function afterSelectedPlacer(res) {
      switch (res.placerEvent) {
        case _ICad.ClassicPlacerEventsEnum.NO_FREE_SLOT:
          console.log("show err pop");
          break;
        case _ICad.ClassicPlacerEventsEnum.SELECT_SLOT:
          this.iCad.selectPlacerSlot(res);
          break;
      }
      this.loader.stop();
    }
  }, {
    key: "afterInsertItemPrj",
    value: function afterInsertItemPrj(res, prj) {
      var _this5 = this;
      return new _promise["default"](function (resolve, reject) {
        _this5.insertItemCad(prj).then(function (resAfter) {
          _this5.iCad.drawAll(false, prj, resolve, _this5.loader.progressWithTotal, _this5.hasToCenterZoom);
        });
      });
    }
  }, {
    key: "afterInsertDuplicatedItemsPrj",
    value: function afterInsertDuplicatedItemsPrj(rows, prj) {
      var _this6 = this;
      var oldIds = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      return new _promise["default"](function (resolve, reject) {
        _this6.resolveInsertItemsCad(rows, prj, oldIds).then(function (data) {
          _this6.iCad.drawAll(false, prj, resolve, _this6.loader.progressWithTotal, _this6.hasToCenterZoom);
        })["catch"](reject);
      });
    }
  }]);
  return DuplicateItem3D;
}(DuplicateItem);
exports.DuplicateItem3D = DuplicateItem3D;
var DuplicateItem2D = /*#__PURE__*/function (_DuplicateItem2) {
  (0, _inherits2["default"])(DuplicateItem2D, _DuplicateItem2);
  var _super3 = (0, _createSuper2["default"])(DuplicateItem2D);
  function DuplicateItem2D(loader) {
    (0, _classCallCheck2["default"])(this, DuplicateItem2D);
    return _super3.call(this, loader);
  }
  (0, _createClass2["default"])(DuplicateItem2D, [{
    key: "afterSelectedPlacer",
    value: function afterSelectedPlacer(res) {
      switch (res.placerEvent) {
        case _ICad.ClassicPlacerEventsEnum.NO_FREE_SLOT:
          console.warn("no free slot");
          break;
        case _ICad.ClassicPlacerEventsEnum.SELECT_SLOT:
          console.warn("no placer in 2D");
          break;
      }
      this.loader.stop();
    }
  }, {
    key: "afterInsertItemPrj",
    value: function afterInsertItemPrj(res, prj) {
      var _this7 = this;
      return new _promise["default"](function (resolve, reject) {
        _this7.insertItemCad(prj).then(resolve)["catch"](reject);
      });
    }
  }, {
    key: "afterInsertDuplicatedItemsPrj",
    value: function afterInsertDuplicatedItemsPrj(rows, prj) {
      var _this8 = this;
      var oldIds = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      return new _promise["default"](function (resolve, reject) {
        _this8.resolveInsertItemsCad(rows, prj, oldIds).then(resolve)["catch"](reject);
      });
    }
  }]);
  return DuplicateItem2D;
}(DuplicateItem);
exports.DuplicateItem2D = DuplicateItem2D;
//# sourceMappingURL=DuplicateItem.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@3cad/nextcore/lib/commonjs/classes/DuplicateItem.js
// module id = 1105
// module chunks = 142